import React from 'react';
import { useExitIntent } from '../hooks/useExitIntent';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function ExitIntentPopup() {
  const {
    isOpen,
    close
  } = useExitIntent();
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[9998] flex items-center justify-center p-5" style={{
    background: 'rgba(0,0,0,0.75)',
    backdropFilter: 'blur(4px)'
  }} role="dialog" aria-modal="true" aria-label="Oferta especial antes de irte" onClick={e => {
    if (e.target === e.currentTarget) close();
  }} data-id="element-30">
      <div className="bg-white rounded-card-lg py-12 px-10 max-w-[520px] w-full text-center relative animate-pop-in shadow-[0_20px_60px_rgba(0,0,0,0.4)]" data-id="element-31">
        <button className="absolute top-4 right-5 bg-transparent border-none text-[1.4rem] cursor-pointer text-gris-suave transition-colors duration-200 hover:text-negro-carbon" onClick={close} aria-label="Cerrar" data-id="element-32">
          ✕
        </button>

        <div className="text-[3rem] mb-4" data-id="element-33">⚠️</div>

        <h3 className="font-display text-[1.5rem] text-negro-carbon mb-3 leading-[1.3]" data-id="element-34">
          ¿Segura que quieres irte sin resolver la inflamación?
        </h3>

        <p className="text-gris-suave text-[0.93rem] leading-[1.7] mb-6" data-id="element-35">
          Mañana vas a despertar sintiéndote igual que hoy. Este protocolo
          cuesta <strong className="text-negro-carbon" data-id="element-36">$6.36</strong> — una sola
          vez — y puede cambiar cómo te sientes en 48 horas. ¿Vale la pena al
          menos intentarlo?
        </p>

        <a href="https://simplementemejor.com/cart/51819834016024:1" className="block py-4 px-6 rounded-full font-bold no-underline mb-3 text-white text-[0.95rem] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(43,74,66,0.4)]" style={{
        background: 'linear-gradient(135deg, #2B4A42, #3D6358)'
      }} onClick={e => {
        e.preventDefault();
        trackAddToCart();
        close();
        setTimeout(() => {
          window.location.href = 'https://simplementemejor.com/cart/51819834016024:1';
        }, 300);
      }} data-id="element-37">
          Sí, quiero mis $6.36 de cambio real →
        </a>

        <button className="text-gris-suave text-[0.8rem] cursor-pointer underline bg-transparent border-none font-body" onClick={close} data-id="element-38">
          No, prefiero seguir igual.
        </button>
      </div>
    </div>;
}